var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { connect } from 'react-redux';
import { Grid, Popup, Label } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import ExtendIcon from 'components/Icons/ExtendIcon';
import moment from 'moment';
import DeleteIcon from '../../../../components/Icons/DeleteIcon';
import DesktopIcon from '../../../../components/Icons/DesktopIcon';
import ShareIcon from '../../../../components/Icons/InviteIcon';
import { showModal } from '../../../../actions/modalActions';
import styleConstants from '../../../../assets/styles/style-constants';
var SandboxItemActions = function (props) {
    var data = props.data, showActionModal = props.showActionModal;
    var onExtend = function () {
        showActionModal({
            type: 'extend',
            data: __assign(__assign({}, data), { clickedFrom: 'settings' }),
        });
    };
    var onAddToDesktop = function () {
        window.neo4jSandbox.tracking.event('SANDBOX_ADD_TO_DESKTOP_CLICK', {});
        showActionModal({
            type: 'addToDesktop',
            data: { usercase: data.usecase },
        });
    };
    var onTerminate = function () {
        showActionModal({ type: 'terminate', data: __assign({}, data) });
    };
    var onInvite = function () {
        showActionModal({ type: 'invite', data: __assign({}, data) });
    };
    var getProjectNameForDesktop = function () {
        var expiryDate = moment(data.expires).format('D MMM');
        return "Sandbox (expires ".concat(expiryDate, "): ").concat(data.usecase_long_name, " ");
    };
    return (React.createElement(Grid, null,
        React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("div", { className: "pull-right" },
                React.createElement("div", { style: { cursor: 'pointer' } },
                    React.createElement(Button, { basic: true, icon: React.createElement(DesktopIcon, { color: styleConstants.colors.charcoal, size: 14, viewBox: undefined }), size: "small", onClick: onAddToDesktop, className: "font-regular", href: "neo4j-desktop://remote/add?url=bolt://".concat(data.ip, ":").concat(data.boltPort, "&username=neo4j&name=").concat(encodeURI(getProjectNameForDesktop()), "&accessToken=").concat(data.password, "&encrypted=false") }, "Add to Neo4j Desktop project"))),
            React.createElement("div", { className: "mb1 font-small" },
                "Neo4j Desktop",
                React.createElement(Label, { color: "blue", size: "small", className: "ml2" }, "New")),
            React.createElement("p", { className: "font-small color-aluminum" },
                "Add this as",
                ' ',
                React.createElement("em", null,
                    React.createElement("strong", null, "remote database")),
                ' ',
                "to Neo4j Desktop")),
        React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid item-extend-wrapper" },
            React.createElement("div", { className: "pull-right" },
                React.createElement(Popup, { content: "You have already extended this project", position: "bottom center", disabled: !data.hasExtended, trigger: React.createElement("div", { style: { cursor: 'pointer' } },
                        React.createElement(Button, { basic: true, icon: React.createElement(ExtendIcon, { color: styleConstants.colors.charcoal, size: 14 }), size: "small", onClick: onExtend, className: "font-regular", disabled: data.hasExtended }, "Extend")) })),
            React.createElement("p", { className: "mb1 font-small" }, "Extend"),
            React.createElement("p", { className: "font-small color-aluminum" }, "Extend your project for an additional 7 days (can be done only once)")),
        React.createElement(Grid.Column, { width: 16, className: "border-bottom" },
            React.createElement("div", { className: "pull-right" },
                React.createElement(Button, { basic: true, className: "font-regular", icon: React.createElement(ShareIcon, { color: styleConstants.colors.charcoal, size: 18, viewBox: undefined }), size: "small", onClick: onInvite }, "Invite")),
            React.createElement("p", { className: "mb1 font-small" }, "Invite"),
            React.createElement("p", { className: "font-small color-aluminum" }, "Collaborate with your team by inviting them to this project.")),
        React.createElement(Grid.Column, { width: 16 },
            React.createElement(Button, { className: "pull-right font-regular", onClick: onTerminate, color: "pink", basic: true, icon: React.createElement(DeleteIcon, { color: styleConstants.colors.danger, size: 14, viewBox: undefined }), size: "small" }, "Terminate"),
            React.createElement("p", { className: "mb1 font-small" }, "Terminate"),
            React.createElement("p", { className: "font-small color-aluminum" }, "Terminating will delete all your data. This is irreversible."))));
};
var mapDispatchToProps = function (dispatch) { return ({
    showActionModal: function (data) { return dispatch(showModal(data)); },
}); };
export default connect(null, mapDispatchToProps)(SandboxItemActions);
